<template>
  <div class="container">
    <h4 class="cardD">Capítulos especiales</h4>

    <div class="row mt-3">
      <div class="col-6" v-if="constitutiva.tipo_societario != 'S de RL'">
        <label for="">Reglas de control corporativo</label>

        <div v-if="constitutiva.roleStaff">
          <b-form-checkbox v-model="constitutiva.reglas_control" :disabled="disabledCapitulosEspeciales"></b-form-checkbox>
        </div>
        <div v-else>
          <b-form-checkbox v-model="constitutiva.reglas_control" :disabled="disabledCapitulosEspeciales"></b-form-checkbox>
        </div>

        <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.reglas_control">
          La cotización básica no incluye esta opción.
        </label>
      </div>
      <div class="col-6">
        <label for="">Reglas para asambleas telemáticas</label>

        <div v-if="constitutiva.roleStaff">
          <b-form-checkbox v-model="constitutiva.reglas_asambleas" :disabled="disabledCapitulosEspeciales"></b-form-checkbox>
        </div>
        <div v-else>
          <b-form-checkbox v-model="constitutiva.reglas_asambleas" :disabled="disabledCapitulosEspeciales"></b-form-checkbox>
        </div>

        <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.reglas_asambleas">
          La cotización básica no incluye esta opción.
        </label>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-6">
        <label for="">Exclusión de accionistas</label>

        <div v-if="constitutiva.roleStaff">
          <b-form-checkbox v-model="constitutiva.exclusion_accionistas" :disabled="disabledCapitulosEspeciales"></b-form-checkbox>
        </div>
        <div v-else>
          <b-form-checkbox v-model="constitutiva.exclusion_accionistas" :disabled="disabledCapitulosEspeciales"></b-form-checkbox>
        </div>

        <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.exclusion_accionistas">
          La cotización básica no incluye esta opción.
        </label>
      </div>
    </div>

    <div class="mt-4">
      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button type="submit" class="btn-fill orange-btn" :disabled="disabledCapitulosEspeciales">Guardar</b-button>
          <b-button variant="success" class="btn-fill" :disabled="disabledCapitulosEspeciales" @click="validar">Validar</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabCapitulosEspeciales",

  props: {
    constitutiva: { type: Object },
  },

  data() {
    return {
      // form: {
      //   reglas_control: null,
      //   reglas_asambleas: null
      // }
    };
  },

  computed: {
    disabledCapitulosEspeciales() {
      const formulario = this.constitutiva.formularios.find((f) => f.formulario === "CapitulosEspeciales");

      return formulario?.valido == 1;
    },
  },

  methods: {
    validar() {
      this.$emit("validaForm", "CapitulosEspeciales");
    },
  },
};
</script>
